import React, {useEffect, useState} from 'react';
import cn from 'classnames';

import Skeleton from 'coreComponents/Skeleton';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

import {BadgesProvider} from './context/BadgesContext';
import {IBadgesProps} from './IBadges';
import {Badge} from './Subcomponents';

import styles from './Badges.module.scss';

const Badges = ({text, color, classNames, ids, onBadgesLoaded}: IBadgesProps) => {
	const {managerRepository} = useGeneralProvider();
	const [loaded, setLoaded] = useState(false);
	const [badgesContents, setBadgesContents] = useState<string[]>([]);
	const badgesIds = ids;

	useEffect(() => {
		const cmsProvider = managerRepository.getContentMgr().getCMSProvider();

		cmsProvider
			.getContent('badgeItems', {
				variables: {
					ids: ids,
				},
			})
			.then(async (data) => {
				if (data?.badgeCollection?.items) {
					const cmsDataBuilder = cmsProvider.getBuilder();
					const badgesBuilt = data.badgeCollection.items.map((b) => cmsDataBuilder.build(b));

					setBadgesContents(badgesBuilt);

					if (typeof onBadgesLoaded === 'function') {
						onBadgesLoaded(badgesBuilt);
					}
				}
			})
			.finally(() => {
				setLoaded(true);
			});
	}, [badgesIds?.join('')]);

	if (!loaded) {
		return ids.map((id) => <Skeleton key={id} height="40px" />) as unknown as React.ReactElement;
	}

	const style: Record<string, string> = {};

	if (color) {
		style.color = color;
	}

	if (!text) {
		return '';
	}

	return (
		<div className={cn(classNames, styles['badge'])}>
			<BadgesProvider value={{badgesList: badgesContents || []}}>
				<span className="badge" style={style}>
					{text}
				</span>
			</BadgesProvider>;

		</div>
	);
};

Badges.Badge = Badge;

export default Badges;